module.exports = __webpack_public_path__ + "img/icon_download_button.ccaa5298.svg";